import blueHydrangea from '../assets/hydrangea_blue_new.png';
import greyHydrangea from '../assets/hydrangea_grey_new.png';

export default function LoadingAnimation() {
  return (
    <div className="logo-wrap">
      <img
        src={greyHydrangea}
        className="logo"
        alt="loading base"
      />

      <img
        src={blueHydrangea}
        className="logo logo-fill"
        alt="loading fill"
      />
    </div>
  );
}
